export default function TaskIcon() {
  return (
    <svg
      aria-hidden="true"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 22.5H15C20 22.5 22 20.5 22 15.5V9.5C22 4.5 20 2.5 15 2.5H9C4 2.5 2 4.5 2 9.5V15.5C2 20.5 4 22.5 9 22.5Z"
        stroke="#A1A1A1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3691 9.37891H17.6191"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.38086 9.37891L7.13086 10.1289L9.38086 7.87891"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3691 16.3789H17.6191"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.38086 16.3789L7.13086 17.1289L9.38086 14.8789"
        stroke="#A1A1A1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
